module.exports = __webpack_public_path__ + "static/media/estrellaDammCup.b7377199.jpg";